export class Inventory extends EventTarget {
    constructor(items = []) {
        super();
        this.items = new Map();
        this.subs = new Set();
        this.add(items);
    }
    get size() {
        return this.items.size;
    }
    *[Symbol.iterator]() {
        for (const item of this.items.values()) {
            yield item;
        }
    }
    subscribe(sub) {
        if (!this.subs.has(sub)) {
            this.subs.add(sub);
            sub(this);
        }
        return () => this.subs.delete(sub);
    }
    get(itemId) {
        return this.items.get(itemId);
    }
    add(items) {
        const addedItems = [];
        for (const item of items) {
            if (!this.items.has(item.id)) {
                this.items.set(item.id, item);
                addedItems.push(item);
            }
        }
        if (addedItems.length > 0) {
            this.dispatchEvent(new CustomEvent('add', {
                detail: addedItems
            }));
            this.emit();
        }
    }
    delete(itemIds) {
        const deletedItems = [];
        for (const itemId of itemIds) {
            if (this.items.has(itemId)) {
                deletedItems.push(this.items.get(itemId));
                this.items.delete(itemId);
            }
        }
        if (deletedItems.length > 0) {
            this.dispatchEvent(new CustomEvent('delete', {
                detail: deletedItems
            }));
            this.emit();
        }
        return deletedItems;
    }
    emit() {
        this.subs.forEach(sub => sub(this));
    }
    toJSON() {
        return [...this.items.values()];
    }
}
